import { Route } from '@angular/router';
import { departmentByIdResolver } from '@features/settings/departments/department-by-id.resolver';
import { SETTINGS_SLUGS } from '@routes/routes.types';
import { subscriptionGuard } from '../billing/guards/subscription.guard';
import { settingsAdminGuard } from '../settings-admin.guard';
import { SettingsDepartmentsService } from './services/settings-departments.service';
import { DepartmentsTableService } from './departments-table/departments-table.service';

export const DEPARTMENTS_SLUGS = {
    table: 'table',
    form: 'form',
} as const;
export const DEPARTMENTS_PARAMS = {
    id: 'id',
} as const;

export const DEPARTMENTS_ROUTE: Route = {
    path: SETTINGS_SLUGS.departments,
    title: 'Departments',
    canActivate: [settingsAdminGuard, subscriptionGuard],
    children: [
        {
            path: DEPARTMENTS_SLUGS.table,
            title: 'Departments - Overview',
            loadComponent: () =>
                import(
                    '@features/settings/departments/departments-table-page/departments-table-page.component'
                ).then(m => m.DepartmentsTablePageComponent),
        },
        {
            path: DEPARTMENTS_SLUGS.form,
            title: 'Departments - Create',
            loadComponent: () =>
                import(
                    '@features/settings/departments/department-form/department-form.component'
                ).then(m => m.DepartmentFormComponent),
        },
        {
            path: `${DEPARTMENTS_SLUGS.form}/:${DEPARTMENTS_PARAMS.id}`,
            title: 'Departments - Update',
            loadComponent: () =>
                import(
                    '@features/settings/departments/department-form/department-form.component'
                ).then(m => m.DepartmentFormComponent),
            resolve: { department: departmentByIdResolver },
        },
        {
            path: '',
            pathMatch: 'full',
            redirectTo: DEPARTMENTS_SLUGS.table,
        },
    ],
};
